import { ActionIcon, Input } from '@mantine/core';
import { Icon } from '@uag/react-core';

import 'app/modules/wallforming/custom-styles/customSearchInputStyle.css';

interface SearchInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
}

export const SearchInput = ({ value, onChange, placeholder = 'Search...' }: SearchInputProps) => {
    return (
        <div className="relative w-full h-full border border-border-light bg-background-default">
            <div className="absolute left-0.5 top-1/2 transform -translate-y-1/2">
                <Icon className="w-5 m-auto pl-1" icon="search" size="xl" />
            </div>
            <Input
                className="flex justify-items-stretch justify-stretch h-full w-full pl-7 pr-6.5 text-sm overflow-visible bg-background-transparent"
                placeholder={placeholder}
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />
            <div className="absolute right-0.5 top-1/2 transform -translate-y-1/2">
                {value && (
                    <ActionIcon className="action-icon-small" onClick={() => onChange('')}>
                        close
                    </ActionIcon>
                )}
            </div>
        </div>
    );
};
